#@import DetectFlash
#@import Modernizr
#@export DealCarousel.Helpers

window.DealCarousel ?= {}

DEFAULT_EL = '.featured-image'

DealCarousel.Helpers =
  getMedia: (carousel) ->
    {dealImages, forceVideos, dealVideos, videoPosition} = carousel

    # clone images array as we might modify it with video
    media = dealImages.slice 0
    showVideos = forceVideos or DetectFlash.hasFlash or !!(Modernizr?.video)

    if showVideos and dealVideos?.length > 0
      #For now, it is assumed that only one video per deal exists.
      #This logic should be revaluated for future enhancements to support multiple deals
      media.splice videoPosition, 0, dealVideos[0]

    {media, showVideos}

  prepareCarouselOptions: (carousel, currentDealMedia, featuredImage, i18n) ->
    {dealId, el, imageQuality, imageZoomState, mediaHeight, prefetchImages, showProductSizing, showThumbs, lazyLoadThumbs, lazyLoadFeatured, featuredImageThumbnail, featuredImageLowQuality} = carousel

    switch imageZoomState
      when "hover"
        zoomMessage = i18n.t '.hoverZoom'
      when "click"
        zoomMessage = i18n.t '.clickZoom'
      else
        zoomMessage = false

    carouselOptions =
      collection: currentDealMedia
      el: el or DEFAULT_EL
      imageQuality: imageQuality
      imageZoomState: imageZoomState
      mediaHeight: mediaHeight
      prefetchImages: prefetchImages
      showThumbs: showThumbs
      uuid: dealId
      zoomMessage: zoomMessage
      showProductSizing: showProductSizing
      lazyLoadThumbs: lazyLoadThumbs
      lazyLoadFeatured: lazyLoadFeatured
      featuredImageThumbnail: featuredImageThumbnail
      featuredImageLowQuality: featuredImageLowQuality

    if showProductSizing then carouselOptions.compareSizeMessage = i18n.t '.compareSize'

    if featuredImage? then carouselOptions.featured = currentDealMedia.findWhere baseURL: featuredImage

    carouselOptions

  setVideoLoaderFlags: (showVideos, carousel) ->
    loadKaltura = false
    loadOoyala = false
    loadYoutube = false

    if showVideos and (!kWidget? or !OO? or !YT?)
      for video in carousel.dealVideos or []
        loadKaltura = true if not loadKaltura and video.provider is "KALTURA"
        loadOoyala = true if not loadOoyala and video.provider is "OOYALA"
        loadYoutube = true if not loadYoutube and video.provider is "YOUTUBE"

    {loadKaltura, loadOoyala, loadYoutube}

  loadVideoScripts: (carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube) ->
    if loadKaltura and not kWidget?
      $.getScript(carousel.kalturaScriptUrl).fail ->
        currentCarouselView.collection.remove currentCarouselView.collection.where provider: "KALTURA"
        currentCarouselView.collection.classes += ' script-load-fail' unless currentCarouselView.collection.classes.indexOf('script-load-fail') > -1
        currentCarouselView.render()

    if loadOoyala and not OO?
      $.getScript(carousel.ooyalaScriptUrl).fail ->
        currentCarouselView.collection.remove currentCarouselView.collection.where provider: "OOYALA"
        currentCarouselView.collection.classes += ' script-load-fail' unless currentCarouselView.collection.classes.indexOf('script-load-fail') > -1
        currentCarouselView.render()

    if loadYoutube and not YT?
      $.getScript(carousel.youtubeScriptUrl).fail ->
        currentCarouselView.collection.remove currentCarouselView.collection.where provider: "YOUTUBE"
        currentCarouselView.collection.classes += ' script-load-fail' unless currentCarouselView.collection.classes.indexOf('script-load-fail') > -1
        currentCarouselView.render()

  loadScripts: (carouselOptions) ->
    {showProductSizing} = carouselOptions
    if showProductSizing
      rootPath = if document.location.protocol is 'https:'
        'https://az646174.vo.msecnd.net/tangiblee-static'
      else
        'http://wcdn.tangiblee.com/tangiblee-static'

      caller = document.createElement('script')
      caller.src = "#{rootPath}/caller.min.js?v=3ujn9jg82"
      caller.id = 'tangiblee-caller'
      document.body.appendChild(caller)
      tangibleeTimeoutId = undefined

      initTangiblee = ->
        if typeof Tangiblee is 'function'
          clearInterval(tangibleeTimeoutId) if tangibleeTimeoutId
          TangibleeScript = new Tangiblee()
          TangibleeScript.init
            clientDomain: 'www.groupon.com',
            widgetLoadingMode: 'onButtonClick'
        else
          tangibleeTimeoutId = setTimeout(initTangiblee, 100)

      initTangiblee()
